import {
    CLOSE_QUOTE_MODAL,
    CloseQuoteModalAction,
    OPEN_QUOTE_MODAL,
    OpenQuoteModalAction,
    TOGGLE_QUOTE_MODAL,
    ToggleQuoteModalAction,
} from './types';

export function toggleQuoteModal(): ToggleQuoteModalAction {
    return {
        type: TOGGLE_QUOTE_MODAL,
    };
}

export function openQuoteModal(): OpenQuoteModalAction {
    return {
        type: OPEN_QUOTE_MODAL,
    };
}

export function closeQuoteModal(): CloseQuoteModalAction {
    return {
        type: CLOSE_QUOTE_MODAL,
    };
}
